// locale-override.js — forcer BTA à utiliser la langue Shopify plutôt que le navigateur
(function () {
  try {
    var lang = document.documentElement.lang || 'fr';
    Object.defineProperty(navigator, 'language', {
      get: function () { return lang; },
      configurable: true
    });
    Object.defineProperty(navigator, 'languages', {
      get: function () { return [lang]; },
      configurable: true
    });
    Object.defineProperty(navigator, 'userLanguage', {
      get: function () { return lang; },
      configurable: true
    });
  } catch (e) {}
}());
